import { ProtectedRoute } from 'components/ui-routing/ProtectedRoute'
import { HomeOverview } from './HomeOverview'

export const homeRoutesChildren = [
  {
    index: true,
    element: <ProtectedRoute component={HomeOverview} />,
  },
]
